import * as Scrivito from "scrivito";
import { chunk } from "lodash-es";
import jsonData from "./font-awesome-free-icons.json";

function FontAwesomeSelector({ widget, value }) {
  // curl call for getting all free icons
  // curl -H "Content-Type: application/json" -d '{ "query": "query { release(version: \"6.1.2\") { icons(license: \"free\") {id, styles, membership {free}} } }" }' https://api.fontawesome.com
  const { icons } = jsonData.data.release;

  const translatedIcons = icons.flatMap((icon) =>
    icon.membership.free.map((ver) => ({ id: icon.id, prefix: `fa${ver[0]}` }))
  );

  return (
    <div className="container">
      {chunk(translatedIcons, 3).map((group, idx) => (
        <div className="row" key={`g-${idx}`}>
          {group.map((icon, index) => (
            <div className="col-4" key={index}>
              <IconEntry
                icon={icon}
                active={value === `${icon.prefix} la-${icon.id}`}
                onClick={() => {
                  widget.update({
                    iconCss: `${icon.prefix} la-${icon.id}`,
                    icon: "",
                  });
                }}
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

function IconEntry({ icon, active, onClick }) {
  return (
    <button
      type="button"
      className={`text-truncate text-left btn-block m-2 btn btn-outline-dark ${
        active ? "active" : ""
      }`}
      onClick={onClick}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <i className={`${icon.prefix} fa-${icon.id} fa-2x`} />
        <small className="align-middle ps-2">{icon.id}</small>
      </div>
    </button>
  );
}
export default Scrivito.connect(FontAwesomeSelector);
